package team.platforma.dictionary_di

import team.platforma.dictionary_data.di.dictionaryDataModule
import team.platforma.dictionary_data.di.dictionaryDatabaseModule
import team.platforma.dictionary_domain.di.dictionaryDomainModule
import team.platforma.dictionary_presentation.di.dictionaryPresentationModule

fun dictionaryDiProvider() = listOf(
    dictionaryDatabaseModule,
    dictionaryDataModule,
    dictionaryDomainModule,
    dictionaryPresentationModule
)